import CryptoJS from "crypto-js";

function EncryptData(data, location) {
  const jsonString = JSON.stringify(data);
  const encrypted = CryptoJS.AES.encrypt(
    jsonString,
    process.env.REACT_APP_ACCESS_KEY,
  ).toString();
  localStorage.setItem(location, encrypted);
}

export default EncryptData;
